import { call, put } from "redux-saga/effects";
import { exceptionHandler, exceptionHandlerForUpdate } from "../pages/common/functions";
import VideoHotlineCategoryService from "../services/api/videoHotlineCategoryService 1";
import { videoHotlineCatgoryConstants } from "../actions/constants/videoHotlineCategoryConstants";

// For get all category & search result
function* videoHotlineCategoryGetAllCategory(request: any) {
	try {
		const result = yield call(
			VideoHotlineCategoryService.videoHotlineCategoryGetAll,
			request.input
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: videoHotlineCatgoryConstants.VideoHotlineCategoryGetByfilterSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: videoHotlineCatgoryConstants.VideoHotlineCategoryGetByfilterFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: videoHotlineCatgoryConstants.VideoHotlineCategoryGetByfilterFailure,
			payload: e,
		});
	}
}

// For update the category status
function* videoHotlineCategoryStatusUpdate(input: any) {
	try {
		const result = yield call(
			VideoHotlineCategoryService.videoHotlineCategoryStatusUpdate,
			input.input
		);
		const res = exceptionHandlerForUpdate(result);
		if (res.status) {
			yield put({
				type: videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateStatusSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateStatusFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateStatusFailure,
			payload: e,
		});
	}
}

// For create category
function* videoHotlineCategoryCreate(input: any) {
	try {
		const result = yield call(
			VideoHotlineCategoryService.videoHotlineCategoryCreate,
			input.input
		);
		const res = exceptionHandlerForUpdate(result);
		if (res.status) {
			yield put({
				type: videoHotlineCatgoryConstants.VideoHotlineCategoryCreateSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: videoHotlineCatgoryConstants.VideoHotlineCategoryCreateFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: videoHotlineCatgoryConstants.VideoHotlineCategoryCreateFailure,
			payload: e,
		});
	}
}

// For update category
function* videoHotlineCategoryUpdate(input: any) {
	try {
		const result = yield call(
			VideoHotlineCategoryService.videoHotlineCategoryUpdate,
			input.input
		);
		const res = exceptionHandlerForUpdate(result);
		if (res.status) {
			yield put({
				type: videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateFailure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateFailure,
			payload: e,
		});
	}
}

// For delete category
function* videoHotlineCategoryDelete(request: any) {
	try {
		const result = yield call(
			VideoHotlineCategoryService.videoHotlineCategoryDelete,
			request.input
		);
		var res = exceptionHandlerForUpdate(result);
		if (res.status) {
			yield put({
				type: videoHotlineCatgoryConstants.VideoHotlineCategoryDeleteSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: videoHotlineCatgoryConstants.VideoHotlineCategoryDeleteFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: videoHotlineCatgoryConstants.VideoHotlineCategoryDeleteFailure,
			payload: error,
		});
	}
}

export const videoHotlineCategorySaga = {
	videoHotlineCategoryGetAllCategory,
	videoHotlineCategoryStatusUpdate,
	videoHotlineCategoryCreate,
	videoHotlineCategoryUpdate,
	videoHotlineCategoryDelete
};
